/**
 * Invitations API Service
 *
 * API client functions for user-to-user reflection sharing invitations.
 * All endpoints require authentication via apiClient.
 */

import { apiClient } from "./api";
import type {
  InvitationResponse,
  InvitationAcceptResponse,
} from "@/types/invitation";

const API_PREFIX = import.meta.env.VITE_API_V1_PREFIX || "/api/v1";

export async function createInvitation(
  reflectionId: string,
  recipientEmail: string
): Promise<InvitationResponse> {
  const response = await apiClient.post(
    `${API_PREFIX}/reflection-invitations/`,
    {
      reflection_id: reflectionId,
      recipient_email: recipientEmail,
    }
  );
  return response.data;
}

export async function getPendingInvitations(): Promise<InvitationResponse[]> {
  const response = await apiClient.get(
    `${API_PREFIX}/reflection-invitations/pending`
  );
  return response.data;
}

export async function getSentInvitations(
  reflectionId: string
): Promise<InvitationResponse[]> {
  const response = await apiClient.get(
    `${API_PREFIX}/reflection-invitations/sent`,
    {
      params: { reflection_id: reflectionId },
    }
  );
  return response.data;
}

export async function acceptInvitation(
  invitationId: string
): Promise<InvitationAcceptResponse> {
  const response = await apiClient.post(
    `${API_PREFIX}/reflection-invitations/${invitationId}/accept`
  );
  return response.data;
}

export async function declineInvitation(invitationId: string): Promise<void> {
  await apiClient.post(
    `${API_PREFIX}/reflection-invitations/${invitationId}/decline`
  );
}

export async function resolveToken(token: string): Promise<InvitationResponse> {
  const response = await apiClient.get(
    `${API_PREFIX}/reflection-invitations/resolve/${token}`
  );
  return response.data;
}
